import * as React from "react";
import { Create, Datagrid, DateField, DeleteWithConfirmButton, Edit, EmailField, List, ReferenceField, ReferenceInput, required, SaveButton, SelectInput, Show, SimpleForm, SimpleShowLayout, TextField, TextInput} from "react-admin";

const convertEmptyStringToUndefined = v => v === '' ? undefined : v;

export const UserCreate = () => (
    <Create>
        <SimpleForm>
            <TextInput source="full_name" fullWidth validate={required()} />
            <TextInput source="email" fullWidth validate={required()} />
            <SelectInput label="Select Role" source="roles" choices={[
                { id: 'companyadmin', name: 'Company Admin' },
                { id: 'superadmin', name: 'Super Admin' },
            ]} validate={required()}/>
            <ReferenceInput source="parent_company_id" reference="parent_companies"><SelectInput optionText="name" optionValue="id" parse={convertEmptyStringToUndefined} /></ReferenceInput>
        </SimpleForm>
    </Create>
);

export const UserList = () => (
    <List hasCreate={true} bulkActionButtons={false} >
        <Datagrid rowClick="show">
            <TextField source="full_name" />
            <EmailField source="email" />
            <TextField source="roles" />
            <ReferenceField source="parent_company_id" reference="parent_companies"><TextField source="name" /></ReferenceField>
            <DeleteWithConfirmButton />
        </Datagrid>
    </List>
);

export const UserUpdate = () => (
    <Edit>
        <SimpleForm>
        FullName : <TextField source="full_name" />
        Email : <EmailField source="email" />
        <SelectInput label="Select Role" source="roles" choices={[
                { id: 'companyadmin', name: 'Company Admin' },
                { id: 'superadmin', name: 'Super Admin' },
            ]}/>
            <ReferenceInput source="parent_company_id" reference="parent_companies"><SelectInput optionText="name" optionValue="id" /></ReferenceInput>
            </SimpleForm>
    </Edit>
);

export const UserShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="full_name" />
            <EmailField source="email" />
            <TextField source="roles" />
            <TextField source="uid" />
            <ReferenceField source="parent_company_id" reference="parent_companies"><TextField source="name" /></ReferenceField>
            <DateField source="createdAt" />
            <TextField source="updatedAt" />
        </SimpleShowLayout>
    </Show>
);